import React from "react";

import IconSelectField from "../../../shared/components/selectField/IconSelectField";
import { getCustomCategoriesOptionList } from "../../../shared/utility";
import { EMPTY_STRING, globalConstants } from "../../../constants";

const CustomItemCategorySelectField = ({
  setFieldValue,
  customCategories,
  values,
  isDisabled = false,
  ...props
}) => {
  const handleCategoryChange = (option, setFieldValue) => {
    setFieldValue("category_name", option.value);
    setFieldValue("subcategory", EMPTY_STRING);
  };

  return (
    <IconSelectField
      label="Category"
      options={getCustomCategoriesOptionList(
        customCategories,
        values.productType
      )}
      name="category_name"
      placeHolder="Category..."
      isClearable={false}
      isDisabled={isDisabled}
      customOnChange={(option) => handleCategoryChange(option, setFieldValue)}
    />
  );
};

export default CustomItemCategorySelectField;
